<template>
  <div
    class="accordion-panel"
    :class="{
      expanded: expanded,
      disabled: disabled,
    }"
  >
    <div
      class="accordion-header"
      :class="{ disabled: disabled }"
      @click="$emit('toggle', 'willLocation')"
    >
      <div class="header-main">
        <div class="header-icon">
          <v-icon
            :color="
              completed
                ? this.whitelabel.colors.leftPanelGreen
                : this.whitelabel.colors.leftPanelIconGrey
            "
            size="24"
          >
            {{ icons.mdiCheckCircle }}
          </v-icon>
        </div>

        <div class="header-title">
          <h3>SET WILL LOCATION</h3>
        </div>

        <div class="header-chevron">
          <v-icon color="#666" size="20">
            {{ expanded ? icons.mdiChevronUp : icons.mdiChevronDown }}
          </v-icon>
        </div>
      </div>
    </div>

    <div class="expanded-container" :class="{ expanded: expanded }">
      <div
        class="status-container"
        :style="{ marginBottom: this.vaultStored ? '30px' : '8px' }"
      >
        <p class="status-text">
          Location:
          <span class="status-value">
            <span
              v-if="this.vaultStored"
              :style="{
                color: this.whitelabel.colors.leftPanelGreen,
              }"
            >
              {{ determineWillLocation }}</span
            >
            <span
              v-else
              :style="{
                color: this.locationNotSet
                  ? this.whitelabel.colors.leftPanelOrange
                  : this.whitelabel.colors.leftPanelGreen,
              }"
            >
              {{ determineWillLocation }}</span
            >
          </span>
        </p>
      </div>

      <div class="accordion-content">
        <div class="content-wrapper" v-if="!this.vaultStored">
          <div class="section-content">
            <div class="content-margins">
              <p v-if="!this.testator.willLocation">
                Where are you storing your originally signed will?
              </p>

              <p v-else>Have you changed your will location?</p>
            </div>
            <div class="action-buttons">
              <GradientButton
                :fill="locationNotSet"
                :title="'Set Will location'"
                @gradientButtonClicked="$emit('willLocation')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mdiChevronDown, mdiChevronUp, mdiCheckCircle } from '@mdi/js';

  export default {
    name: 'SetWillLocation',
    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      completed: {
        type: Boolean,
        default: false,
      },
      testator: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        icons: {
          mdiChevronDown: mdiChevronDown,
          mdiChevronUp: mdiChevronUp,
          mdiCheckCircle: mdiCheckCircle,
        },
      };
    },
    computed: {
      determineWillLocation() {
        if (!!this.testator.dateStored) {
          return 'Old Mutual Wills Vault';
        }
        if (this.locationNotSet) {
          return 'Location not set';
        }
        return this.testator.willLocation.length > 200
          ? this.testator.willLocation.substring(0, 200) + '...'
          : this.testator.willLocation;
      },
      locationNotSet() {
        return !this.testator.willLocation;
      },
      vaultStored() {
        return !!this.testator.dateStored;
      },
    },
  };
</script>
